<template>
    <div class="news-detail">
        <div class="news-detail__header">
            <slot name="title">
                <z-caption
                    v-if="detailArticle.item.name"
                    tag="h2"
                    size="lt"
                    class="news-detail__title"
                >
                    {{ detailArticle.item.name }}
                </z-caption>
            </slot>
            <div class="news-detail__tags">
                <z-tag v-if="detailArticle.item.theme.value">
                    {{ detailArticle.item.theme.value }}
                </z-tag>
            </div>
            <z-date theme="simple" :from="detailArticle.item.activeFrom" size="m"></z-date>
            <div v-if="detailArticle.item.image.link" class="news-detail__image">
                <img :src="detailArticle.item.image.link" alt="">
                <sub>{{descriptionImage}}</sub>
            </div>
        </div>

        <div class="news-detail__content html-content" v-html="detailArticle.item.detailText"  />

        <z-page-nav :data="detailArticle.nav" :button-text="textLocales.button" class="u-mt-m"></z-page-nav>
    </div>
</template>
<script setup>
import { onMounted } from 'vue'
import { useGetter } from '@/composable/useGetter'
import { localize } from '@/utils/i18n';

const {app} = useGetter(['app'])
const detailArticle = app.value.components['news-detail']
import {useStore} from 'vuex';

const store = useStore();


const hasExtension = /\.(jpe?g|png|gif|tiff|webp)$/i.test(detailArticle.item.image.name);
const descriptionImage = hasExtension ? '' : detailArticle.item.image.name;

const textLocales = {
    title: localize({
        ru: 'Новости',
        en: 'News',
        cn: '新闻'
    }),
    description: localize({
        ru: 'Иркутская нефтяная компания (ИНК)&nbsp;&mdash; независимый производитель углеводородного сырья ' +
           'в&nbsp;Восточной Сибири. Компания создана в&nbsp;2000&nbsp;году, ведет геологическое изучение, ' +
           'разведку и&nbsp;разработку участков недр на&nbsp;территории Иркутской области, Красноярского края ' +
           'и&nbsp;Республики Саха (Якутия). ИНК в&nbsp;2023 году вошла в&nbsp;топ-5 среди лучших работодателей ' +
           'ТЭК и&nbsp;в&nbsp;топ-100 лучших работодателей России рейтинга HeadHunter.',
        en: 'Irkutsk Oil Company (INK) is an independent hydrocarbon producer in Eastern Siberia. The Company was ' +
            'established in 2000 and conducts geological study, exploration and development of subsoil blocks ' +
            'in the Irkutsk Region, Krasnoyarsk Region and the Republic of Sakha (Yakutia). In 2023, INK was ' +
            'ranked in the top 5 among the best employers in the fuel and energy sector and in the top 100 best ' +
            'employers in Russia in the HeadHunter rating.',
        cn: '伊尔库茨克石油公司 (INK) 是俄罗斯一家独立的碳氢化合物原料生产商。该公司成立于 2000 年，在伊尔库茨克州、克拉斯诺亚尔斯克边疆区和萨哈共和国（雅库特）开展地质研究、勘探和开发地下资源。该公司在“能源、原材料开采和加工”类别中位列最佳雇主前五名，并在 hh.ru 雇主评级中位列百强。'
    }),
    button: localize ({
        ru: 'Вернуться к списку',
        en: 'Back to list',
        cn: '返回列表'
    }),
    schema: {
        author: localize({
            ru: 'Иркутская нефтяная компания',
            en: 'Irkutsk Oil company',
            cn: '伊尔库茨克石油公司'
        }),
        publisher: localize({
            ru: 'Иркутская нефтяная компания',
            en: 'Irkutsk Oil company',
            cn: '伊尔库茨克石油公司'
        })
    }
}

const setTitle = (title) => {
    store.dispatch('SetHeroTitle', title);
    store.dispatch('SetHeroTitleTag', 'h2');
};

setTitle(textLocales.title);

onMounted(() => {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        'headline': detailArticle.item.name,
        'image': detailArticle.item.image.link,
        'datePublished': detailArticle.item.activeFrom,
        'articleBody': detailArticle.item.detailText,
        'description': detailArticle.item.previewText,
        'author': {
            '@type': 'Organization',
            'name': textLocales.schema.author
        },
        'publisher': {
            '@type': 'Organization',
            'name': textLocales.schema.publisher,
            'logo': {
                '@type': 'ImageObject',
                'url': '/media/img/logo/logo-white.svg'
            }
        }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
});
</script>

<style lang="scss">
.news-detail {
    &__header {
        @include margin-level(bottom, L);
    }

    &__tags {
        @include margin-level(bottom, 2XS);
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    &__image{
        max-width: 50%;
        @include margin-level(top, L);

        @include breakpoint(v-tablet){
            max-width: 100%;
        }
    }

    &__notice{
        font-size: var(--typography-m);
    }
}
</style>
